import { Component } from '@opten/compiler/metadata/component';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { isAncestorOfClass } from '@opten/dom/is-ancestor-of-class';
import { scrollToId } from '@opten/scroll/scroll-to-id';
import dispatchCustomEvent from '@opten/events/dispatch-custom-event';
import { debounce } from '@opten/reactive/debounce';

declare const imagesLoaded: any;
declare const Modernizr: any;

@Component({ className: 'js-nav' })
export class Navbar {
	private mobileBreakpoint = 992;
	private stickyElem: HTMLElement;
	private dropdowns: HTMLElement[];
	private dropdownTitles: HTMLElement[];
	private scrollToElements: HTMLElement[];
	private navbar: HTMLElement;
	private navbarToggler: HTMLElement;
	private backTop: HTMLElement;

	constructor(public element: HTMLElement) {
		this.navbar = document.getElementsByClassName(
			'js-header'
		)[0] as HTMLElement;
		this.navbarToggler = document.getElementsByClassName(
			'c-navbar__toggler'
		)[0] as HTMLElement;
		this.backTop = document.getElementsByClassName(
			'js-back-top'
		)[0] as HTMLElement;
		this.stickyElem = element.getElementsByClassName(
			'js-nav-sticky'
		)[0] as HTMLElement;
		this.dropdowns = Array.from(
			element.getElementsByClassName('js-nav-dropdown')
		) as HTMLElement[];
		this.dropdownTitles = Array.from(
			element.getElementsByClassName('js-nav-title')
		) as HTMLElement[];
		this.scrollToElements = Array.from(
			document.getElementsByClassName('js-scroll-to')
		) as HTMLElement[];

		this.showBackTop();
		this.checkSticky();
		window.addEventListener('scroll', () => {
			this.checkSticky();
			this.showBackTop();
		});

		this.setHeaderHeight();
		window.addEventListener('resize', debounce(() => {
			this.setHeaderHeight();
		}, 300));

		this.dropdowns.forEach((dropdown) => {
			const parent = dropdown.closest('.c-navbar__item');
			const toggler = parent.querySelector('a') as HTMLElement;
			toggler.addEventListener('click', (e) => {
				if (hasClass(parent, 'is-open')) {
					// dont close, open page - this.closeNav(e, parent);
				} else {
					this.closeAll();
					this.openNav(e, parent);
				}
			});
			if (Modernizr.touch == false) {
				parent.addEventListener('mouseenter', (e) => {
					if (window.innerWidth >= this.mobileBreakpoint) {
						this.openNav(e, parent);
					}
				});
				parent.addEventListener('mouseleave', (e) => {
					if (window.innerWidth >= this.mobileBreakpoint) {
						this.closeNav(e, parent);
					}
				});
			}
		});
		this.dropdownTitles.forEach((dropdownTitle) => {
			dropdownTitle.addEventListener('click', (e) => {
				this.closeNav(e, dropdownTitle.closest('.c-navbar__item'));
			});
		});
		document.addEventListener('click', (ev) =>
			this.closeOnOutsideClick(ev.target)
		);

		this.scrollToElements.forEach((target) => {
			target.addEventListener('click', (e) => {
				this.scrollTo(target.getAttribute('href'));
				this.closeAll();
				this.closeMainNav();
			});
		});

		new imagesLoaded(
			document.body,
			setTimeout(() => {
				this.scrollTo(location.hash);
			}, 300)
		);
	}

	private openNav(event, item) {
		event.preventDefault();
		addClass(item, 'is-open');
	}

	private closeNav(event, item) {
		event.preventDefault();
		removeClass(item, 'is-open');
	}

	private closeAll() {
		this.dropdowns.forEach((dropdown) => {
			const parent = dropdown.parentElement;
			removeClass(parent, 'is-open');
		});
	}

	private closeMainNav() {
		if (hasClass(this.navbarToggler, 'is-active')) {
			dispatchCustomEvent(this.navbarToggler, 'click');
		}
	}

	private closeOnOutsideClick(target) {
		if (isAncestorOfClass(target, 'c-navbar', true) == false) {
			this.closeAll();
		}
	}

	private scrollTo(item) {
		if (item) {
			const target = item.replace('#', '');
			if (document.getElementById(target)) {
				const offset = this.navbar.offsetHeight * -1;
				scrollToId(target, undefined, undefined, offset);
			}
		}
	}

	private showBackTop() {
		if (window.scrollY > 100) {
			addClass(document.body, 'is-scrolled');
			addClass(this.backTop, 'fade--show');
		} else {
			removeClass(document.body, 'is-scrolled');
			removeClass(this.backTop, 'fade--show');
		}
	}

	private checkSticky() {
		if (
			hasClass(this.stickyElem, 'is-sticky') === false &&
			this.stickyElem.getBoundingClientRect().top <= 0
		) {
			this.element.style.marginBottom =
				this.stickyElem.offsetHeight + 'px';
			addClass(this.stickyElem, 'is-sticky');
		} else if (
			hasClass(this.stickyElem, 'is-sticky') &&
			this.element.getBoundingClientRect().top +
				this.element.offsetHeight >=
				0
		) {
			removeClass(this.stickyElem, 'is-sticky');
			this.element.removeAttribute('style');
		}
	}

	private setHeaderHeight() {
		this.element.style.marginTop = `${this.navbar.offsetHeight}px`;
	}
}
